module.exports = __webpack_public_path__ + "static/img/apple-touch-icon-iphone-retina-120x120.5199b12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apple-touch-icon-iphone-retina-120x120.png
// module id = 422
// module chunks = 1